import React from 'react';
import Header from '@kmdpartners/ui-kit/src/CN_Design_System/blocks/Header';
import ExtoleReferFriendWidget from '@creditninja/shared/widgets/extoleReferFriend';
const HeaderBlock = ({ runToggleSidebar, isLogged, hideNav, isSticky, showExtoleReferFriend }) => {
    return (React.createElement(React.Fragment, null,
        showExtoleReferFriend ? React.createElement(ExtoleReferFriendWidget, null) : null,
        React.createElement(Header, { isLogged: isLogged, hideNav: hideNav, handleBurgerClick: runToggleSidebar, isSticky: isSticky })));
};
export default HeaderBlock;
